export class ErrorMessagesEnum {
    public static DuplicatedCodeError: 'managerial-account:duplicated_code_exception'
}